<template>
  <a-modal
      title="修改密码"
      :width="500"
      :visible="visible"
      :confirmLoading="false"
      @ok="() => { $emit('ok') }"
      @cancel="() => { $emit('cancel') }"
  >
    <a-form-model ref="adminForm" :model="form" :label-col="{span:6}" :wrapper-col="{span:15}" autoComplete="off">
      <a-form-model-item label="旧密码" prop="oldPassword"
        :rules="[{ required: true, message: '必填，不能为空', trigger: 'blur' }]">
        <a-input v-model="form.oldPassword" type="password" />
      </a-form-model-item>
      <a-form-model-item label="新密码" prop="password"
        :rules="[{ required: true, message: '必填，不能为空', trigger: 'blur' }]">
        <a-input v-model="form.password" type="password" />
      </a-form-model-item>
      <a-form-model-item label="重复新密码" prop="repeatPassword"
        :rules="[
          { required: true, message: '必填，不能为空', trigger: 'blur' },
          { validator: validateRepeat, trigger: 'blur' }
        ]">
        <a-input v-model="form.repeatPassword" type="password" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      form: {
        oldPassword: '',
        password: '',
        repeatPassword: ''
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.form = { oldPassword: '', password: '', repeatPassword: '' };
        this.$nextTick(() => {
          if (this.$refs.adminForm) {
            this.$refs.adminForm.clearValidate();
          }
        });
      }
    }
  },
  methods: {
    initForm() {
      this.form = { oldPassword: '', password: '', repeatPassword: '' };
      this.$nextTick(() => {
        if (this.$refs.adminForm) {
          this.$refs.adminForm.clearValidate();
        }
      });
    },
    validateRepeat(rule, value, callback) {
      if (value !== this.form.password) {
        callback(new Error('两次输入的密码不一致'));
        return;
      }
      callback();
    }
  }
}
</script>

<style scoped>

</style>
